import { PUBLIC_JOBS_HOME_URL } from '@/constants/jobsSite';
import { SIGNUP_PATH } from '@/constants/signup';
import type { LandingRoadmapAction } from '@/types/landingRoadmap';

// Peoply landing (Roadmap v9) scroll eğrileri — tasarım dosyasındaki DCLogic'ten alınmıştır. CV bölümü (y=1360-2730)
// 1.6 kat uzatıldı, sonrasındaki her şey 822px aşağı kaydı; yol A ilerleme tablosu yeni çizgiden ölçüldü.
// *_Y dizileri sayfa içi y koordinatı (px), *_PROGRESS dizileri o noktadaki çizgi ilerlemesi (0-1).

export const LANDING_ROADMAP_ARTBOARD_WIDTH = 1280;
// Artboard'a uygulanan zoom değeri bu CSS değişkeniyle markup'a da verilir (sticky öğelerdeki vh telafisi için).
export const LANDING_ROADMAP_ZOOM_VAR = '--lr-zoom';

export const LANDING_ROADMAP_PATH_A_Y = [
  400, 403, 406.6, 410.9, 415.8, 421.4, 427.6, 434.5, 442, 450.1, 458.6, 467.8, 477.7, 488.3, 499.6, 511.9, 525, 539.7,
  556.3, 574, 592.4, 610.8, 628.5, 645.2, 660, 673.2, 685.5, 696.9, 707.5, 717.5, 727, 736.2, 745, 753.3, 761, 768,
  774.7, 781.1, 787.3, 793.6, 800, 806.1, 811.4, 816.5, 821.6, 827.1, 833.4, 840.9, 850, 860.7, 872.6, 885.5, 899.4,
  913.9, 929, 944.4, 960, 976.1, 992.9, 1010.3, 1028.1, 1046.2, 1064.3, 1082.3, 1100, 1116.7, 1132.2, 1147.2, 1162.5,
  1178.7, 1196.6, 1216.8, 1240, 1266.5, 1295.6, 1327, 1360, 1414.9, 1471, 1527.7, 1584, 1641, 1699.5, 1759.4, 1820,
  1881.1, 1942.6, 2003.5, 2064, 2123.5, 2182.1, 2240.5, 2299, 2358.1, 2418.4, 2480.2, 2544, 2610.9, 2680.6, 2752.3,
  2825, 2897.4, 2968.8, 3038.1, 3104, 3167.8, 3230.9, 3292.8, 3353, 3411, 3466.6, 3519, 3562, 3589.8, 3614.7, 3637.6,
  3658.9, 3679.3, 3699.6, 3720.3, 3742, 3764.4, 3786.5, 3808.6, 3830.8, 3853, 3875.6, 3898.5, 3922, 3945.6, 3969.2,
  3992.9, 4017, 4041.7, 4067.3, 4094, 4122, 4151.8, 4183.2, 4216, 4249.5, 4283.3, 4317, 4350, 4382, 4412.5, 4442,
  4470.8, 4499.5, 4528.5, 4558.2, 4589.3, 4622, 4656.3, 4691.6, 4727.9, 4765.1, 4803.2, 4842.1, 4881.7, 4922, 4963.4,
  5006, 5049.6, 5093.9, 5138.6, 5183.3, 5227.9, 5272, 5316.1, 5360.7, 5405.4, 5450.1, 5494.4, 5538, 5580.6, 5622,
  5662.1, 5701.2, 5739.5, 5777, 5813.9, 5850.3, 5886.3, 5922, 5959, 5997.9, 6037.3, 6075.8, 6111.8, 6144.2, 6171.4,
  6192, 6192,
];
export const LANDING_ROADMAP_PATH_A_PROGRESS = [
  0, 0.0013, 0.003, 0.005, 0.0073, 0.0097, 0.0121, 0.0146, 0.017, 0.0194, 0.022, 0.0247, 0.0275, 0.0302, 0.0328, 0.0353,
  0.0376, 0.04, 0.0427, 0.0454, 0.0483, 0.0512, 0.054, 0.0567, 0.0591, 0.0613, 0.0633, 0.0652, 0.0671, 0.069, 0.0711,
  0.0735, 0.0763, 0.0797, 0.0836, 0.0879, 0.0926, 0.0975, 0.1023, 0.1072, 0.1118, 0.1165, 0.1214, 0.1264, 0.1314,
  0.1363, 0.1408, 0.145, 0.1487, 0.1521, 0.1551, 0.158, 0.1607, 0.1634, 0.1661, 0.1688, 0.1715, 0.1743, 0.1771, 0.18,
  0.1828, 0.1857, 0.1886, 0.1914, 0.1942, 0.1968, 0.1994, 0.202, 0.2048, 0.2077, 0.2109, 0.2143, 0.2181, 0.2224, 0.2271,
  0.2321, 0.2374, 0.2461, 0.2549, 0.2638, 0.2727, 0.2816, 0.2907, 0.3001, 0.3096, 0.3192, 0.3288, 0.3383, 0.3478,
  0.3571, 0.3663, 0.3755, 0.3847, 0.3939, 0.4034, 0.4131, 0.423, 0.4335, 0.4444, 0.4556, 0.467, 0.4784, 0.4895, 0.5004,
  0.5107, 0.5207, 0.5306, 0.5403, 0.5498, 0.5589, 0.5676, 0.5759, 0.5827, 0.5872, 0.5913, 0.5951, 0.5987, 0.6022,
  0.6056, 0.6089, 0.6124, 0.6159, 0.6193, 0.6228, 0.6263, 0.6299, 0.6335, 0.6372, 0.641, 0.6448, 0.6486, 0.6524, 0.6564,
  0.6604, 0.6645, 0.6688, 0.6733, 0.678, 0.6829, 0.6881, 0.6933, 0.6986, 0.7039, 0.7091, 0.7141, 0.7189, 0.7236, 0.7283,
  0.733, 0.7378, 0.7427, 0.7478, 0.753, 0.7585, 0.7641, 0.7699, 0.7758, 0.7819, 0.788, 0.7942, 0.8005, 0.807, 0.8137,
  0.8205, 0.8275, 0.8345, 0.8415, 0.8485, 0.8554, 0.8623, 0.8693, 0.8764, 0.8834, 0.8904, 0.8972, 0.9039, 0.9104,
  0.9167, 0.9228, 0.9288, 0.9347, 0.9405, 0.9463, 0.9519, 0.9575, 0.9634, 0.9695, 0.9757, 0.9817, 0.9874, 0.9925,
  0.9968, 1, 1,
];
export const LANDING_ROADMAP_PATH_B_Y = [
  8496, 8500.2, 8504.9, 8510.2, 8515.9, 8522.1, 8528.8, 8535.8, 8543.1, 8550.8, 8558.8, 8567.1, 8575.6, 8584.2, 8593.1,
  8602.1, 8611.1, 8620.3, 8629.5, 8638.7, 8647.8, 8656.9, 8666, 8674.9, 8683.6, 8692.3, 8701.1, 8710, 8718.9, 8728,
  8737.1, 8746.3, 8755.6, 8764.9, 8774.3, 8783.8, 8793.3, 8802.9, 8812.5, 8822.2, 8832, 8841.8, 8851.6, 8861.5, 8871.4,
  8881.4, 8891.4, 8901.4, 8911.4, 8921.7, 8932.5, 8943.7, 8955.2, 8967.1, 8979.1, 8991.4, 9003.7, 9016.1, 9028.5,
  9040.8, 9052.9, 9064.9, 9076.6, 9088, 9099, 9109.6, 9119.6, 9129.1, 9138, 9146.2, 9153.6, 9160.2, 9166, 9166,
];
export const LANDING_ROADMAP_PATH_B_PROGRESS = [
  0, 0.0062, 0.0133, 0.0214, 0.0304, 0.0401, 0.0506, 0.0617, 0.0733, 0.0854, 0.0979, 0.1107, 0.1237, 0.1368, 0.1501,
  0.1633, 0.1766, 0.1897, 0.2026, 0.2154, 0.2279, 0.2403, 0.2524, 0.2643, 0.2761, 0.2881, 0.3006, 0.3136, 0.3273,
  0.3416, 0.3564, 0.3718, 0.3876, 0.4039, 0.4204, 0.4372, 0.4542, 0.4712, 0.4881, 0.505, 0.5217, 0.5381, 0.5543, 0.57,
  0.5853, 0.6002, 0.6147, 0.6287, 0.6425, 0.6564, 0.6709, 0.6859, 0.7014, 0.7175, 0.7339, 0.7508, 0.7679, 0.7851,
  0.8025, 0.8199, 0.8373, 0.8544, 0.8712, 0.8876, 0.9035, 0.9189, 0.9334, 0.9472, 0.9601, 0.9719, 0.9825, 0.9919, 1, 1,
];

export const LANDING_ROADMAP_NODE_Y = [800, 1360, 2096, 2832, 3592, 4062, 4692, 5152, 5612];
export const LANDING_ROADMAP_CV_STEPS_Y = [1360, 2096, 2832];
export const LANDING_ROADMAP_EXAM_STEPS_Y = [4692, 5152, 5612];
export const LANDING_ROADMAP_SECTION_TOPS = [760, 1230, 3552, 4022, 4562];

export const LANDING_ROADMAP_HORIZONTAL_TOP = 6062;
export const LANDING_ROADMAP_HORIZONTAL_MAX_TRANSLATE = 2304;
export const LANDING_ROADMAP_EXIT_Y = 8496;

// CV kartı sticky: top = max(36px, 50vh - 403px). Kart tam görününce dolum başlar; sonraki metin okuma
// çizgisinin (%55 vh) bu kadar altına geldiğinde adım değişir. Son adımda dolum bu mesafede tamamlanır.
export const LANDING_ROADMAP_CV_SECTION_TOP = 1230;
export const LANDING_ROADMAP_CARD_STICKY_MIN_TOP = 36;
export const LANDING_ROADMAP_CARD_HALF_HEIGHT = 403;
export const LANDING_ROADMAP_CV_STEP_LEAD = 50;
export const LANDING_ROADMAP_CV_FILL_TAIL = 400;
// Dolum ilerlemesinde adım 2 ve 3 başlangıç değerleri (karalama eşikleriyle uyumlu).
export const LANDING_ROADMAP_CV_STEP_PROGRESS = [0.3, 0.62];

// Hızlı scroll'da adımlar atlanmasın diye: CV dolumu en fazla bu hızla (birim/sn) ilerler, sınav her adımda
// en az bu kadar kalır. Bölümler, üst kenarı ekranın bu oranına girince belirir ve bir daha gizlenmez.
export const LANDING_ROADMAP_CV_PROGRESS_RATE = 0.35;
export const LANDING_ROADMAP_EXAM_STEP_DWELL_MS = 850;
// Uzun bekleme sonrası ilk karede CV bir anda dolmasın diye kare süresi bu değerle sınırlanır.
export const LANDING_ROADMAP_MAX_FRAME_MS = 50;
export const LANDING_ROADMAP_REVEAL_LINE = 0.9;
export const LANDING_ROADMAP_REVEAL_SECTIONS = [0, 2, 3, 4];

export const LANDING_ROADMAP_CV_DOODLE_THRESHOLDS = [0.04, 0.12, 0.18, 0.24, 0.32, 0.4, 0.48, 0.58, 0.68];
export const LANDING_ROADMAP_CV_STROKE_THRESHOLDS = [0.1, 0.38, 0.3, 0.46, 0.54, 0.86, 0.64];

// Tasarımdaki tıklanabilir öğeler (span/button) i18n anahtarıyla (landingPage.roadmap.<anahtar>) eşlenir; çalışma anında
// aktif dildeki metne çevrilip boşluklar normalize edilerek karşılaştırılır.
export const LANDING_ROADMAP_ACTIONS: Record<string, LandingRoadmapAction> = {
  navLogin: { type: 'navigate', to: '/auth/login' },
  // The listings are on their own domain (or the server-rendered /jobs): a full page load.
  navJobs: { type: 'external', href: PUBLIC_JOBS_HOME_URL },
  navPricing: { type: 'navigate', to: '/pricing' },
  navSignup: { type: 'navigate', to: SIGNUP_PATH },
  heroDemoCta: { type: 'demo' },
  employerCta: { type: 'demo' },
};

// Platform mega menüsündeki modül satırları (.mi) bu nitelikle modül slug'ını taşır; tıklanınca /platform/<slug>'a gider.
// Satırlar markup'ta MODULE_PAGES ile aynı sırada durur.
export const LANDING_ROADMAP_MODULE_ATTR = 'data-module-slug';

// Çeviriler Türkçeden uzun olabilir; sabit yerleşimli tasarımda taşmasın diye işaretli öğeler sığdırılır.
// Hero başlığı satır sayısını aşarsa yazı boyutu, kartlar yüksekliği aşarsa içerik orantılı küçültülür.
export const LANDING_ROADMAP_FIT_LINES_ATTR = 'data-lr-fit-lines';
export const LANDING_ROADMAP_FIT_HEIGHT_ATTR = 'data-lr-fit-height';
export const LANDING_ROADMAP_FIT_MIN_SCALE = 0.75;
